import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./components/Login";
import HalconPage from "./components/HalconPage";
import LiderPage from "./components/LiderPage";
import AdminPage from "./components/AdminPage";
import WelcomePage from "./components/WelcomePage";
import RegistroPage from "./components/RegistroPage";
import RecuperarPWD from "./components/RecuperarPWD";


const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/halcon"
            element={
              <ProtectedRoute allowedRoles={["halcon"]}>
                <HalconPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lider"
            element={
              <ProtectedRoute allowedRoles={["lider"]}>
                <LiderPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/registro"  element={<RegistroPage />} 
          />
          <Route
            path="/recuperar_pwd"  element={<RecuperarPWD />} 
          />
          <Route path="/" element={<WelcomePage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
